// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-upload[data-v-43f611f2]{margin-bottom:1.5rem!important}.file-upload[data-v-43f611f2]:last-child{margin-bottom:0!important}.custom-file-button input[type=file][data-v-43f611f2]{margin-left:-2px!important}.custom-file-button input[type=file][data-v-43f611f2]::-webkit-file-upload-button{display:none}.custom-file-button input[type=file][data-v-43f611f2]::file-selector-button{display:none}.custom-file-button:hover label[data-v-43f611f2]{background-color:#dde0e3;cursor:pointer}", ""]);
// Exports
module.exports = exports;
